import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import cross from "@iconify/icons-ic/close";
import { DataTable } from 'src/app/pages/models/GetDataList';

@Component({
  selector: "po-tat-popup",
  templateUrl: "po-tat-popup.component.html",
  styleUrls: ["./po-tat-popup.component.scss"]
})
export class PoTatPopup {

  //component variables
  poTatDetailsObject: DataTable;
  poTatDetailsData: any;

  //icons
  cross = cross;

  constructor(
    public dialogRef: MatDialogRef<PoTatPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   * Method to be executed on the initialization of the component
   */
  ngOnInit() {
    this.poTatDetailsObject = this.data.design;
    this.poTatDetailsData = this.data.data;
  }
  cancel() {
    this.dialogRef.close("popup closed");
  }
}
